import { useMutation, useQueryClient } from "@tanstack/react-query";
import { del } from "@truefit/http-utils";

interface ApiError {
    message: string;
    status: number;
}

/** Takes the id of the key to revoke — the endpoint no longer revokes in bulk. */
export const useRevokeApiKeyMutation = (orgId?: number) => {
    const queryClient = useQueryClient();

    return useMutation<void, ApiError, number>({
        mutationFn: async (id) => {
            await del(`/v1.0/user/apikey/${id}`);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['apikey', orgId] });
        },
        onError: (error) => {
            console.error('Failed to revoke API key:', error);
        }
    });
};

export default useRevokeApiKeyMutation;
